import { useContext, useEffect, useState } from 'react';
import { SubItemFormFilling } from '../../Filling/Types';
import TextField from '@mui/material/TextField';
import { GiAcousticMegaphone } from 'react-icons/gi';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { toast } from 'react-toastify';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { trackEventMatomo } from '../../../helpers/matomo';
import { getBase64 } from '../../Filling/Subitens/GetBase64';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import ButtonGroup from '@mui/material/ButtonGroup';
import { NewWebFormContext } from '../../../context/NewWebFormContext';
import CheckIcon from '../CheckIcon';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import AddCommentIcon from '@mui/icons-material/AddComment';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

export default function AdditionalInfo({ subItem }: { subItem: SubItemFormFilling }) {
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [images, setImages] = useState<string[] | null>(null);
  const [comentario, setComentario] = useState<string | null>(null)
  const { ForceUpdate } = useContext(NewWebFormContext);

  const { t } = useTranslation('translation');

  useEffect(() => {
    if (subItem.tipo === 'avaliacao' || subItem.tipo === 'multiple') {
      if (subItem.ocorrencia) {
        setComentario(subItem.ocorrencia)
      }
    }
    if (subItem.obs) {
      setComentario(subItem.obs)
    } if (subItem.img) {
      setImages(subItem.img)
    }
  }, [])

  useEffect(() => {
    if (CheckIcon(subItem, images) === 'ok') {
      subItem.checked = true
    }
  }, [images])

  useEffect(() => {
    if (CheckIcon(subItem, comentario) === 'ok') {
      subItem.checked = true
    }
  }, [comentario])

  useEffect(() => {
    ForceUpdate()
  }, [comentario, images])

  const renderImages = (File: FileList | null) => {
    if (File) {
      Array.from(File).map(e => getBase64(e, (i) => {
        setImages((prev) => prev ? [...prev, i] : [i])
        if (subItem.img) subItem.img = [...subItem.img, i]
        else subItem.img = [i];
      }));
    }
  }

  const compressImage = async (file: File, { quality = 1, type = file.type }) => {
    const imageBitmap = await createImageBitmap(file);

    const canvas = document.createElement('canvas');
    canvas.width = imageBitmap.width;
    canvas.height = imageBitmap.height;
    const ctx = canvas.getContext('2d');
    ctx?.drawImage(imageBitmap, 0, 0);

    return await new Promise((resolve) =>
      canvas.toBlob(resolve, type, quality)
    );
  };

  const renderDetails = () => {
    switch (selectedOption) {
      case 'foto':
        return (
          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Button
              startIcon={<CloudUploadIcon />}
              style={{
                width: 'fit-content',
                backgroundColor: '#643E91',
                color: '#fff',
                marginBottom: '10px',
                cursor: 'pointer',
              }}
            >
              {'Upload Imagens'}
              <>
                <input
                  className='file-input'
                  required={subItem?.obrigatoriedade?.img}
                  value={""}
                  type="file"
                  accept="image/png, image/jpeg"
                  onChange={async (e) => {
                    const files: FileList | null = e.target.files;
                    if (files) {
                      const filesArray: File[] = Array.from(files).map(file => file);
                      for (const file of filesArray) {
                        if (file.size > 100000000) {
                          toast.warn('Arquivo muito grande!');
                          e.target.files = null;
                          e.target.value = '';
                        } else {
                          const compressedFile = await compressImage(file, {
                            quality: 0.1,
                            type: 'image/jpeg',
                          });
                          renderImages([compressedFile] as unknown as FileList)
                        }
                      }
                    }
                  }}
                  multiple
                />
              </>
            </Button>
            {images &&
              <ImageList
                gap={10}
                sx={{ height: 150 }}
                cols={2}
                rowHeight={105}
              >
                {images?.map((item, i) => (
                  <ImageListItem key={`${item}|${i}}`}>
                    <RemoveCircleOutlineIcon
                      sx={{
                        cursor: 'pointer',
                        ":hover": { color: '#ab003c' },
                        position: 'absolute'
                      }}
                      color='error'
                      onClick={() => {
                        trackEventMatomo('foto', 'click', 'img', 'remove imagem')
                        if (images.length > 1) {
                          setImages(images.filter((ele, ind) => ele[ind] !== item[i]))
                          subItem?.img?.filter((ele, ind) => ele[ind] !== item[i])
                        } else {
                          setImages(null)
                          subItem.img = []
                        }
                      }}
                    />
                    <img
                      style={{
                        maxHeight: '100%',
                        objectFit: 'cover',
                        width: 200,
                      }}
                      loading='lazy'
                      src={item}
                      alt={`${i}`}
                    />
                  </ImageListItem>
                ))}
              </ImageList>}
          </Stack>
        )
      case 'comentario':
        return (
          <Stack
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <TextField
              required={subItem?.obrigatoriedade?.ocorrencia}
              multiline
              fullWidth
              maxRows={5}
              rows={4}
              label={t('notifications.ticket.Comentario')}
              value={comentario}
              onChange={(event) => {
                if (subItem.tipo === 'avaliacao' || subItem.tipo === 'multiple') {
                  setComentario(event.target.value)
                  subItem.ocorrencia = event.target.value
                } else {
                  subItem.obs = event.target.value
                  setComentario(event.target.value)
                }
              }}
            />
          </Stack>
        )
      case 'chamado':
        return (
          <div>
            <textarea
              className="textarea has-fixed-size"
              placeholder={t('Filling.ticket')} />
          </div>
        )
    }
  }

  const changeStyle = (value: string) => {
    const style = {
      backgroundColor: selectedOption === value ? '#643E91' : 'inherit',
      color: selectedOption === value ? '#fff' : '#643E91',
      borderColor: selectedOption === value ? '#643E91' : '#643E91',
      ':hover': {
        backgroundColor: selectedOption === value ? '#643E91' : 'inherit',
        color: selectedOption === value ? '#fff' : '#643E91',
        borderColor: selectedOption === value ? '#643E91' : '#643E91',
      }
    }
    return style
  }

  const changeSelected = (value: string) => {
    setSelectedOption(value)
    if (selectedOption === value) {
      setSelectedOption('')
    }
  }

  return (
    <>
      {
        (
          <>
            {subItem.tipo !== 'avaliacao'
              ? <>
                <ButtonGroup size='small' sx={{ marginBottom: '10px', marginTop: '10px' }}>
                  {(subItem.foto || subItem.galeriaFoto) &&
                    <Button
                      sx={changeStyle('foto')}
                      variant={selectedOption === 'foto' ? 'contained' : 'outlined'}
                      size='small'
                      onClick={() => changeSelected('foto')}>
                      Imagens&nbsp;<AddPhotoAlternateIcon />
                    </Button>
                  }
                  {subItem.comentario &&
                    <Button
                      sx={changeStyle('comentario')}
                      variant={selectedOption === 'comentario' ? 'contained' : 'outlined'}
                      size='small'
                      onClick={() => changeSelected('comentario')}>
                      Comentário&nbsp;<AddCommentIcon />
                    </Button>}
                  {subItem.chamadosConfig
                    && <Button
                      sx={changeStyle('chamado')}
                      variant={selectedOption === 'chamado' ? 'contained' : 'outlined'}
                      size='small'
                      onClick={() => changeSelected('chamado')}>
                      Chamado&nbsp;<GiAcousticMegaphone />
                    </Button>}
                </ButtonGroup>
              </> :
              <>
                <ButtonGroup size='small' sx={{ marginBottom: '10px', marginTop: '10px' }}>
                  {!subItem.hideImg &&
                    <Button
                      sx={changeStyle('foto')}
                      variant={selectedOption === 'foto' ? 'contained' : 'outlined'}
                      size='small'
                      onClick={() => changeSelected('foto')}>
                      Imagens&nbsp;<AddPhotoAlternateIcon />
                    </Button>
                  }
                  {!subItem.hideComent &&
                    <Button
                      sx={changeStyle('comentario')}
                      variant={selectedOption === 'comentario' ? 'contained' : 'outlined'}
                      size='small'
                      onClick={() => changeSelected('comentario')}>
                      Comentário&nbsp;<AddCommentIcon />
                    </Button>}
                  {subItem.chamadosConfig
                    && <Button
                      sx={changeStyle('chamado')}
                      variant={selectedOption === 'chamado' ? 'contained' : 'outlined'}
                      size='small'
                      onClick={() => changeSelected('chamado')}>
                      Chamado&nbsp;<GiAcousticMegaphone />
                    </Button>}
                </ButtonGroup>
              </>}
            {renderDetails()}
          </>
        )}
    </>
  )
}